import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '../../../../components/Breadcrumbs/Breadcrumbs';
import { Link } from 'react-router-dom';
import '../../Document/InvoiceForm/InvoiceForm.scss';
import useForm from '../../../../common/hooks/useForm/useForm';
import { formatError } from '../../../../utils/Formatters/Errors/formatError';
import DateHelper from '../../../../utils/DateHelper/DateHelper';
import Entity from '../../../../api/controllers/Company/Entity/Entity';
import InvoiceForm from '../../Document/InvoiceForm/InvoiceForm';
import PurchaseCredit from '../../../../api/controllers/Financial/PurchaseCredit/PurchaseCredit';
import Supplier from '../../../../api/controllers/Financial/Supplier/Supplier';
import LineItemHelper from '../../../../utils/LineItemHelper/LineItemHelper';
import { useNavigate, useParams } from 'react-router';

const PurchaseCreditNoteNew = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [warning, setWarning] = useState();
  const [lineItems, setLineItems] = useState([]);
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const { form, alter } = useForm({
    entityId: id,
    entityReference: '',
    issueDate: DateHelper.today(),
    dueDate: '',
    lineItemsAttributes: [],
  });

  const handleErrors = json => {
    loading && setLoading(false);
    const errorContent = formatError(json);
    const errorCount = errorContent.errors.length;
    setError({
      type: 'error',
      text: {
        errorTitle: `Action Failed, ${errorCount} error${errorCount > 1 ? 's' : ''} to resolve.`,
        errors: errorContent.errors,
      },
    });
  };

  const entityId = id;

  useEffect(() => {
    PurchaseCredit.lineItems({ entityId: entityId }).then(
      json => {
        setLineItems(json.items);
        setLoading(false);
      },
      json => handleErrors(json),
    );
    Entity.show(entityId).then(json => {
      setSupplier(json);
      Supplier.show(json.supplierAccount).then(
        json => {
          calculateDefaultDue(json);
          setLoading(false);
        },
        json => {
          setWarning({ ...json, ...{ status: 'Warning' } });
          setLoading(false);
        },
      );
    });
  }, []);

  const calculateDefaultDue = supplier => {
    if (!supplier) return alter('dueDate', DateHelper.today());
    alter('dueDate', DateHelper.dueDateCalculate(supplier));
  };

  const handleLineItemToggle = itemId => {
    const toggledLines = LineItemHelper.toggleLineNew(form.lineItemsAttributes, itemId);
    alter('lineItemsAttributes', toggledLines);
  };

  const handleSubmit = () => {
    const params = form;
    PurchaseCredit.create(params).then(
      json => navigate(`/financials/purchase_credit_notes/${json.id}`),
      json => handleErrors(json),
    );
  };

  return (
    <div className={'invoice-form'}>
      <Breadcrumbs>
        <Link to={'/financials/purchase_credit_notes'}>Purchase Credit Notes</Link>
        <Link to={`/financials/purchase_credit_notes/new/${entityId}`}>New</Link>
      </Breadcrumbs>
      <div className={'page-content'}>
        <InvoiceForm
          error={error}
          setError={setError}
          alter={alter}
          form={form}
          lineItems={lineItems}
          handleSubmit={handleSubmit}
          lineItemToggle={handleLineItemToggle}
          cancelUrl="/financials/purchase_credit_notes"
          title={
            loading
              ? 'Creating Purchase Credit Note'
              : `Creating Purchase Credit Note for ${supplier?.internalName}`
          }
          warning={warning}
          setWarning={setWarning}
          loading={loading}
        />
      </div>
    </div>
  );
};

PurchaseCreditNoteNew.propTypes = {
  user: PropTypes.object,
};

export default PurchaseCreditNoteNew;
